<template>
  <div class="container">
    <v-card class="mx-2 px-2">
      <v-toolbar class="mt-12" dark color="primary">
        <v-toolbar-title>Dashboard</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-alert color="purple" dark dismissible outlined
          >Los indicadores de Turnos están tomadas en base al estado de los
          mismos.</v-alert
        >
        <v-row class="mt-4">
          <v-col cols="12" md="4" sm="6">
            <v-select
              :items="profsBuscar"
              item-text="nombre"
              item-value="idCancha"
              menu-props="auto"
              label="Cancha"
              hide-details
              prepend-icon="mdi-account"
              v-model="prof"
              dense
              ref="vselect"
              no-data-text="No hay canchas registradas"
              @change="recargarIndicadores"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="6">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="datesFormatted"
                  label="Fecha desde / hasta"
                  readonly
                  v-on="on"
                  prepend-icon="mdi-calendar"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                locale="es-ar"
                range
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                color="cyan"
                v-bind="attrs"
                v-on="on"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item two-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos Totales</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.totales }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span
              >Total de turnos del mes, incluye hasta el último día del mes y
              todos los estados</span
            >
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                v-bind="attrs"
                v-on="on"
                color="cyan"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item four-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos Jugados</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.atendidos }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span>Turnos que realmente fueron jugados en la cancha</span>
          </v-tooltip>
        </v-row>

        <v-row>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                color="cyan"
                v-bind="attrs"
                v-on="on"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item four-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos Ausentes</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.ausentes }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span
              >Turnos que quedaron en estado reservado y que son anteriores a la
              fecha actual</span
            >
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                color="cyan"
                v-bind="attrs"
                v-on="on"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item four-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos Reservados</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.reservados }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span
              >Turnos que están en estado reservado y cuya fecha es igual o
              mayor a la fecha actual</span
            >
          </v-tooltip>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                color="cyan"
                v-bind="attrs"
                v-on="on"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item four-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos Web</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.web }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span
              >Turnos que fueron reservados a través del sitio web, sin tener en
              cuenta su estado</span
            >
          </v-tooltip> -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                color="cyan"
                v-bind="attrs"
                v-on="on"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item four-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos En Espera</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.espera }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span>Turnos en estado en espera</span>
          </v-tooltip>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card color="orange" dark class="mt-2 mx-5">
              <v-list-item four-line>
                <v-list-item-content>
                  <div class="overline mb-4">
                    <v-row class="ml-0 mb-2">
                      <v-icon>mdi-currency-usd</v-icon>
                      <h4 class="ml-2">Ingresos</h4>
                    </v-row>
                    <v-row class="ml-0"></v-row>
                    <v-row class="mr-0 pr-0">
                      <v-spacer></v-spacer>
                      <h1>${{ indicadores.ingresos }}</h1>
                    </v-row>
                    <v-row>
                      <v-icon class="ml-3">mdi-chart-bar</v-icon>
                    </v-row>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="mt-2 mx-5" color="#4278f6" dark>
              <v-card-title>
                <v-icon large left>mdi-chart-bar</v-icon>
                <span class="title font-weight-light"
                  >Ranking de ausencias por jugador</span
                >
              </v-card-title>
              <v-card-text>
                <v-card flat v-if="turnospacientes.length">
                  <v-simple-table ref="tableAusencias">
                    <template v-slot:default>
                      <thead style="background: #4278f6">
                        <tr>
                          <th class="text-left">Nº</th>
                          <th class="text-left">Jugador</th>
                          <th class="text-left">Ausencias</th>
                        </tr>
                      </thead>
                      <tbody style="background: #4278f6; text-align: left">
                        <tr
                          v-for="(item, i) in turnospacientes"
                          :key="item.paciente"
                        >
                          <td>{{ i + 1 }}</td>
                          <td>{{ item.paciente }}</td>
                          <td>{{ item.ausencias }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
                <v-alert v-else text class="mb-0">
                  <div class="d-flex align-center">
                    <v-icon left>mdi-information-outline</v-icon>
                    <span
                      >No hay datos de ausencias para el período
                      seleccionado</span
                    >
                  </div>
                </v-alert>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card class="mt-2 mx-5" color="#147536" dark>
              <v-card-title>
                <v-icon large left>mdi-chart-bar</v-icon>
                <span class="title font-weight-light"
                  >Distribución de Turnos Jugados por Edad</span
                >
              </v-card-title>
              <v-card-text>
                <v-card flat v-if="turnosedad.length">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead style="background: #147536">
                        <tr>
                          <th class="text-left">Nº</th>
                          <th class="text-left">Edad</th>
                          <th class="text-left">Cantidad</th>
                        </tr>
                      </thead>
                      <tbody style="background: #147536; text-align: left">
                        <tr v-for="(item, i) in turnosedad" :key="item.edad">
                          <td class="text-left">{{ i + 1 }}</td>
                          <td>{{ item.edad }}</td>
                          <td>{{ item.cantidad }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
                <v-alert v-else text class="mb-0">
                  <div class="d-flex align-center">
                    <v-icon left>mdi-information-outline</v-icon>
                    <span
                      >No hay datos de distribución por edad para el período
                      seleccionado</span
                    >
                  </div>
                </v-alert>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card class="mt-2 mx-5" color="#6a1b9a" dark>
              <v-card-title>
                <v-icon large left>mdi-account-cancel</v-icon>
                <span class="title font-weight-light"
                  >Ausencias injustificadas de turno fijo</span
                >
              </v-card-title>
              <v-card-text>
                <v-card flat v-if="ausenciasTurnoFijo.length">
                  <v-simple-table
                    fixed-header
                    height="300px"
                    style="background: #6a1b9a"
                  >
                    <template v-slot:default>
                      <thead style="background: #6a1b9a">
                        <tr>
                          <th class="text-left" style="background: #6a1b9a">
                            Jugador
                          </th>
                          <th class="text-left" style="background: #6a1b9a">
                            Cancha
                          </th>
                          <th class="text-left" style="background: #6a1b9a">
                            Hora
                          </th>
                          <th class="text-left" style="background: #6a1b9a">
                            Ausencias injustificadas
                          </th>
                        </tr>
                      </thead>
                      <tbody style="background: #6a1b9a; text-align: left">
                        <tr
                          v-for="item in ausenciasTurnoFijo"
                          :key="`${item.idPaciente}-${item.cancha}-${item.hora}`"
                        >
                          <td>{{ item.jugador }}</td>
                          <td>{{ item.cancha }}</td>
                          <td>{{ item.hora }}</td>
                          <td>{{ item.cantidadAusencias }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
                <v-alert v-else text class="mb-0">
                  <div class="d-flex align-center">
                    <v-icon left>mdi-information-outline</v-icon>
                    <span
                      >No hay ausencias injustificadas de turno fijo para el
                      período seleccionado</span
                    >
                  </div>
                </v-alert>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card class="mt-2 mx-5" color="#b30941" dark>
              <v-card-title>
                <v-icon large left>mdi-chart-bar</v-icon>
                <span class="title font-weight-light">Turnos por cancha</span>
              </v-card-title>
              <v-card-text>
                <v-card flat v-if="turnosprofesional.length">
                  <v-simple-table
                    fixed-header
                    height="300px"
                    style="background: #b30941"
                  >
                    <template v-slot:default>
                      <thead style="background: #b30941">
                        <tr>
                          <th class="text-left" style="background: #b30941">
                            Cancha
                          </th>
                          <th class="text-left" style="background: #b30941">
                            Total Turnos
                          </th>
                          <th class="text-left" style="background: #b30941">
                            Reservados
                          </th>
                          <th class="text-left" style="background: #b30941">
                            Jugados
                          </th>
                          <th class="text-left" style="background: #b30941">
                            Ausentes
                          </th>
                          <th class="text-left" style="background: #b30941">
                            En espera
                          </th>
                        </tr>
                      </thead>
                      <tbody style="background: #b30941; text-align: left">
                        <tr
                          v-for="item in turnosprofesional"
                          :key="item.nombreProfesional"
                        >
                          <td>{{ item.nombreProfesional }}</td>
                          <td>{{ item.cantTotal }}</td>
                          <td>{{ item.cantReservados }}</td>
                          <td>{{ item.cantAtendidos }}</td>
                          <td>{{ item.cantAusentes }}</td>
                          <td>{{ item.cantEnEspera }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
                <v-alert v-else text class="mb-0">
                  <div class="d-flex align-center">
                    <v-icon left>mdi-information-outline</v-icon>
                    <span
                      >No hay datos de turnos por cancha para el período
                      seleccionado</span
                    >
                  </div>
                </v-alert>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn dark color="#24232d" @click="salir">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click.stop="recargarIndicadores"
          :loading="loading"
          :disabled="loading"
        >
          <v-icon left class="mx-1">mdi-refresh</v-icon>Actualizar
        </v-btn>
        <v-btn color="warning" @click.stop="imprimir">Imprimir</v-btn>
      </v-card-actions>
      <ImprimirDashboard
        :visible="showImprimirDashboard"
        :nomProf="nomProf"
        :mesFormatted="mesFormatted"
        :indicadores="indicadores"
        :turnospacientes="turnospacientes"
        :turnosos="turnosos"
        :turnosedad="turnosedad"
        :turnospatologia="turnospatologia"
        :turnosprofesional="turnosprofesional"
        @close="showImprimirDashboard = false"
      ></ImprimirDashboard>
    </v-card>
  </div>
</template>
<script>
import axios from "@/axios-auth";
import router from "@/router";
import ImprimirDashboard from "./ImprimirDashboard.vue";
import moment from "moment";

export default {
  data: (vm) => ({
    showImprimirDashboard: false,
    profsBuscar: [],
    nomProf: "",
    prof: "",
    menu: false,
    modal: false,
    menu2: false,
    dates: [],
    datesFormatted: "",
    turnospacientes: [],
    turnosos: [],
    turnosedad: [],
    turnospatologia: [],
    turnosprofesional: [],
    ausenciasTurnoFijo: [],
    loading: false,
    indicadores: {
      totales: "",
      atendidos: "",
      ausentes: "",
      espera: "",
      web: "",
      ingresos: "",
      reservados: "",
    },
  }),
  computed: {
    mesFormatted() {
      return `${this.datesFormatted}`;
    },
  },
  methods: {
    setInitialDates() {
      const primerDiaMes = moment().startOf("month").format("YYYY-MM-DD");
      const diaActual = moment().format("YYYY-MM-DD");
      this.dates = [primerDiaMes, diaActual];
    },
    recargarIndicadores() {
      this.loading = true;
      this.recargarDashboard();
      this.recargarRankingPacientes();
      this.recarcarRankingEdad();
      this.recargarRankingTurnosProfesional();
      this.recargarAusenciasTurnoFijo();
      this.loading = false;
    },
    recargarDashboard() {
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Dashboard/RecargarDashboard?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.indicadores = response.data;
          else self.indicadores = {};
        })
        .catch(function (error) {});
    },
    recargarRankingPacientes() {
      this.turnospacientes = [];
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Dashboard/RecargarRankingPacientes?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.turnospacientes = response.data;
          else self.turnospacientes = [];
        })
        .catch(function (error) {});
    },
    recarcarRankingEdad() {
      this.turnosedad = [];
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Dashboard/RecargarRankingEdad?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.turnosedad = response.data;
          else self.turnosedad = [];
        })
        .catch(function (error) {});
    },
    recargarRankingTurnosProfesional() {
      this.turnosprofesional = [];
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Dashboard/RecargarRankingTurnosProfesional?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.turnosprofesional = response.data.map((item) => ({
              ...item,
              cantTotal:
                item.cantReservados +
                item.cantEnEspera +
                item.cantAtendidos +
                item.cantAusentes,
            }));
          else self.turnosprofesional = [];
        })
        .catch(function (error) {});
    },
    recargarAusenciasTurnoFijo() {
      this.ausenciasTurnoFijo = [];
      let self = this;
      axios
        .get("/Dashboard/AusenciasInjustificadasTurnoFijo", {
          params: {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idProfesional: this.prof,
            fechaDesde: this.dates[0],
            fechaHasta: this.dates[1],
          },
        })
        .then(function (response) {
          self.ausenciasTurnoFijo = response.data || [];
        })
        .catch(function () {});
    },
    salir() {
      router.push({ path: "/Home" });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}-`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    imprimir() {
      this.nomProf = this.$refs.vselect.selectedItems[0].nombreProfesional;
      this.showImprimirDashboard = true;
    },
  },
  created() {
    this.profsBuscar = [...this.$store.state.usuario.canchas].sort((a, b) =>
      a.nombre.localeCompare(b.nombre),
    );

    if (this.profsBuscar.length > 1) {
      this.profsBuscar.unshift({
        idCancha: 0,
        nombre: "TODOS",
      });
    }
    this.prof = this.profsBuscar[0].idCancha;

    this.setInitialDates();
  },

  watch: {
    dates(val) {
      if (val.length === 2) {
        moment.locale("fr");
        this.datesFormatted =
          moment(val[0]).format("L") + " - " + moment(val[1]).format("L");
        this.menu2 = false;
        this.recargarIndicadores();
      }
    },
  },
  components: {
    ImprimirDashboard,
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
};
</script>
<style scoped>
.container {
  margin-top: 3.8rem;
}
</style>
